import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fingerprint, X } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { isBiometricAvailable, isMobile } from "@/lib/webauthn";
import { fetchBiometricStatus } from "@/lib/api";

const DISMISS_KEY = "fodindin_biometric_invite_dismissed";

export const BiometricInviteBanner = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !isMobile() || localStorage.getItem(DISMISS_KEY)) return;
    let active = true;
    isBiometricAvailable().then(async (avail) => {
      if (!avail || !active) return;
      try {
        const status = await fetchBiometricStatus();
        if (active && !status.enrolled) setShow(true);
      } catch { /* not logged / error: skip */ }
    });
    return () => { active = false; };
  }, [user]);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:max-w-sm" data-testid="biometric-invite-banner">
      <div className="glass-card p-4 flex items-start gap-3 shadow-xl border border-emerald-200 bg-white/95">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-400 text-white grid place-items-center shrink-0">
          <Fingerprint size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-sm">Protegez vos paiements</div>
          <p className="text-xs text-[var(--ink-soft)] mt-0.5">
            Activez votre empreinte digitale : elle sera exigee avant chaque paiement, en plus du code SMS.
          </p>
          <Link to="/parametres" onClick={dismiss} className="inline-block mt-2 text-xs font-bold text-emerald-600" data-testid="biometric-invite-link">
            Activer maintenant →
          </Link>
        </div>
        <button onClick={dismiss} className="text-[var(--ink-soft)] hover:text-black shrink-0" data-testid="biometric-invite-close">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
